import WebServiceRequest from "../../Api/WebServiceRequest";

class MediaLibraryDeleteRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Gallery/Delete");
  }
  setParams(data) {
    console.log(data);
    super.setRequestParam(data);
  }
}
export default MediaLibraryDeleteRequest;
